import {Injectable, inject} from '@angular/core';
import {BaseApiService} from '../base-api.service';
import {FirebaseApi} from '../../firebase-api.service';
import {CommonUtil} from '../../../utils/common.util';
import {Logger} from '../../../utils/logger';

/**
 * The product events only the browser can see, for the admin dashboard.
 *
 * Most of what the dashboard counts is recorded by the server where it
 * happens -- a project created, an export built, a plan changed. These are
 * the features that run entirely here (importing a file, planning a car
 * park, segmenting imagery) and so leave the server nothing to count.
 *
 * The server stamps who and when from the token, keeps only the names and
 * values it allows, and ignores "sign in as" sessions. Guests and embeds are
 * left out here, before anything is sent: a guest's usage is the owner's
 * funnel, counted on the server, and only this side knows it is in a frame.
 * Nothing is stored in the browser.
 */
export type ProductEvent = 'file_imported' | 'car_park_planned' | 'segmentation_run' | 'export_created';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsEventsService extends BaseApiService {
  private readonly firebase = inject(FirebaseApi);

  constructor() {
    super();
  }

  /**
   * Fire and forget. A failure to count is logged and otherwise ignored: it
   * must never cost the user the thing they were doing.
   */
  record(name: ProductEvent, props: {[key: string]: string | number | boolean | string[]} = {},
         projectId?: string): void {
    if (!this.firebase.isRealUser() || CommonUtil.inIframe()) {
      return;
    }
    this.post('/events', {name, props, projectId}).catch(err => Logger.log('analytics event not recorded', name, err));
  }
}
